import type { FilterDataType } from '../types/types';
import { ApplicationTabId } from './application-tabs.constants';

export const STATUS_DATA = [
  {
    id: 'invitation-sent',
    label: 'Invitation sent',
    labelId: 'invitation-sent',
  },
  {
    id: 'renewal-created',
    label: 'Confirm lease renewal',
    labelId: 'confirm-lease-renewal',
  },
  {
    id: 'lease-details',
    label: 'Provide lease details',
    labelId: 'provide-lease-details',
  },
  {
    id: 'in-progress',
    label: 'Application in progress',
    labelId: 'application-in-progress',
  },
  {
    id: 'pending-approval-decision',
    label: 'Pending approval decision',
    labelId: 'pending-approval-decision',
  },
  {
    id: 'pending-payment-signature',
    label: 'Pending Payment/Signature',
    labelId: 'pending-payment-signature',
  },
  {
    id: 'bond-issued',
    label: 'Bond issued',
    labelId: 'deal-closed',
  },
  {
    id: 'denied',
    label: 'Application denied',
    labelId: 'application-denied',
  },
  {
    id: 'closed',
    label: 'Canceled',
    labelId: 'canceled-not-using-theguarantors',
  },
] as const satisfies readonly FilterDataType[];

type StatusId = (typeof STATUS_DATA)[number]['id'];

const ALL_STATUS_IDS: StatusId[] = STATUS_DATA.map((status) => status.id);

/** Every status except the excluded ones, in STATUS_DATA order. */
const statusIdsExcept = (...excluded: StatusId[]): StatusId[] =>
  ALL_STATUS_IDS.filter((id) => !excluded.includes(id));

const DEFAULT_STATUS_FILTERS = {
  drawer: ALL_STATUS_IDS,
  pills: statusIdsExcept('renewal-created'),
};

export const STATUS_FILTERS_BY_TAB = {
  [ApplicationTabId.AllApplications]: DEFAULT_STATUS_FILTERS,
  [ApplicationTabId.NewApplications]: DEFAULT_STATUS_FILTERS,

  [ApplicationTabId.ExpiringSoon]: {
    drawer: [],
    pills: [],
  },

  [ApplicationTabId.RenewalApplications]: {
    drawer: statusIdsExcept('invitation-sent', 'renewal-created', 'lease-details'),
    pills: statusIdsExcept('invitation-sent', 'renewal-created', 'lease-details', 'in-progress'),
  },
} satisfies Record<
  ApplicationTabId,
  {
    drawer: StatusId[];
    pills: StatusId[];
  }
>;
